// extracted by mini-css-extract-plugin
module.exports = {"notselected":"styles_notselected__2dY47","disabled":"styles_disabled__OJZyb","tab":"styles_tab__m5E_J","comingSoon":"styles_comingSoon__8mxUF"};